/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

document.addEventListener('DOMContentLoaded', function () {
  var lastY = window.scrollY;
  var ticking = false;

  function updateHeader() {
    var y = window.scrollY;

  var isHome = document.body.classList.contains('template-index');

  if (isHome && window.innerWidth > 768) {
    if (y > 40) {
      document.body.classList.add('desktop-home-header-solid');
    } else {
      document.body.classList.remove('desktop-home-header-solid');
    }
    document.body.classList.remove('hide-mobile-header');
    lastY = y;
    ticking = false;
    return;
  }

    if (window.innerWidth > 768) {
      document.body.classList.remove('hide-mobile-header');
      lastY = y;
      ticking = false;
      return;
    }

    if (y < 40) {
      document.body.classList.remove('hide-mobile-header');
    } else if (y > lastY) {
      document.body.classList.add('hide-mobile-header');
    } else {
      document.body.classList.remove('hide-mobile-header');
    }

    lastY = y;
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', updateHeader);
  updateHeader();
});

/* =====================================================
   ZTTLPRINT – VARIANTEN + MENGE
===================================================== */

function zttlVariantRow() {
  document
    .querySelectorAll('.template-product .product-single__box')
    .forEach(box => {

      if (box.querySelector(':scope > .zttl-variant-row')) return;

      const variant = box.querySelector(
        ':scope > .product-single__box__block--variant_picker'
      );

      const quantity = box.querySelector(
        ':scope > .product-single__box__block--quantity_selector'
      );

      if (!variant || !quantity) return;

      if (!variant.querySelector('.product-form__swatch__item--color')) return;

      const row = document.createElement('div');
      row.className = 'zttl-variant-row';

      if (variant.querySelectorAll('fieldset').length > 1) {
        row.classList.add('zttl-variant-row--multi');
      }

      box.insertBefore(row, variant);

      row.appendChild(variant);
      row.appendChild(quantity);
    });
}

document.addEventListener('DOMContentLoaded', zttlVariantRow);
document.addEventListener('shopify:section:load', zttlVariantRow);